//
// Login:
//

export const index = {
    path   : '/announcements/',
    method : 'GET',
    version: '/v1'
}

export const getItem = {
  path   : '/announcements/:announcement_id',
  method : 'GET',
  version: '/v1'
}

export const addItem = {
  path   : '/announcements/',
  method : 'POST',
  version: '/v1'
}

export const updateItem = {
  path   : '/announcements/:announcement_id',
  method : 'POST',
  version: '/v1'
}

export const deleteItem = {
  path   : '/announcements/:announcement_id',
  method : 'DELETE',
  version: '/v1'
}
